import { render } from "./App.vue?vue&type=template&id=1586171a"
const script = {}

import exportComponent from "/Users/xianbinlin/workplace/work/projects/notionWeb/app-notion2web/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])